var map = {
	"./今日均价.png": "./src/assets/images/index/nav/schj/今日均价.png",
	"./价格监测点.png": "./src/assets/images/index/nav/schj/价格监测点.png",
	"./年销售量.png": "./src/assets/images/index/nav/schj/年销售量.png",
	"./年销售额.png": "./src/assets/images/index/nav/schj/年销售额.png",
	"./物流监测点.png": "./src/assets/images/index/nav/schj/物流监测点.png",
	"./鲜果收入.png": "./src/assets/images/index/nav/schj/鲜果收入.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/index/nav/schj sync recursive ^\\.\\/.*\\.png$";